<div class="soporte-container">
    <h2>{{ titulo }}</h2>

    <div class="contacto-container">
        <h5 class="subtitle">Contacto</h5>

        <div class="campo">
            <label>Dirección:</label>
            <span>{{ contacto.address }}</span>
        </div>

         <div class="campo">
            <label>Correo:</label>
            <span>{{ contacto.email }}</span>
        </div>

         <div class="campo">
            <label>Nombre de ejecutivo:</label>
            <span>{{ contacto.manager }}</span>
        </div>

         <div class="campo">
            <label>Teléfono:</label>
            <span>{{ contacto.phone }}</span>
        </div>

        <div class="campo">
            <label>Acceso a ServiceDesk:</label>
            <span class="link" (click)="openHelpDesk(contacto.helpDeskUrl)">
                {{ contacto.helpDeskUrl }}
            </span>
        </div>

    </div>

    <hr style="border: 1px solid #ffffff88; width: 100%; margin-left: 0; margin-top: 20px; margin-bottom: 20px;">

    <div class="poliza-container">
        <h5 class="subtitle">Poliza</h5>

        <div class="campo">
            <label>Poliza:</label>
            <span>{{ poliza.no }}</span>
        </div>

         <div class="campo">
            <label>Tipo de licencia:</label>
            <span>{{ poliza.type }}</span>
        </div>

         <div class="campo">
            <label>Estatus de licencia:</label>
            <span>{{ poliza.status }}</span>
        </div>

        <div class="campo">
            <label>Fecha de inicio:</label>
            <span>{{ poliza.startDate | date: 'dd/MM/yyyy' }}</span>
        </div>

         <div class="campo">
            <label>Fecha de terminación:</label>
            <span>{{ poliza.finalDate | date: 'dd/MM/yyyy' }}</span>
        </div>

         <div class="campo">
            <label>Fecha de activación:</label>
            <span>{{ poliza.activationDate | date: 'dd/MM/yyyy' }}</span>
        </div>
    </div>

    <h6 class="semaforo" [ngClass]="color">{{descripcionRenovacion}}</h6>
</div>